import { createActionName } from "../../../utility"

export const reducerName = "integrations"

export const INTEGRATION = createActionName(reducerName, "INTEGRATION")
export const INTEGRATIONS = createActionName(reducerName, "INTEGRATIONS")
